import classNames from "classnames";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { Form, FormMessage, FormControl, OrderFullDecorator, st } from "lib/index";

import { stateSelector, validate } from "./index";

@connect(
  (state) => ({
    submitLoading: stateSelector(state).submitLoading,
    errors: stateSelector(state).errors,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        validate,
      },
      dispatch
    )
)
export default class FinishOrderModalForm extends React.PureComponent {
  render() {
    const { errors, valid, submitLoading } = this.props;

    return (
      <div>
        {!!errors.base && <FormMessage error={errors.base} />}
        {I18n.t("papp.orders.utils.confirm_finish_message")}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/orders/FinishOrderModal/FinishOrderModalForm.jsx